import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_chart_of_acc_RowClass} from '../../dbschema';

export class ChartOfAccContainerModel extends BaseContainerModel {
  bl_fi_mst_chart_of_acc: bl_fi_mst_chart_of_acc_RowClass = new bl_fi_mst_chart_of_acc_RowClass();
}
